import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { baseUrl } from "../../config/baseUrl";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

export default function EduUsersView({
  userData,
  setUserData,
  setShowList,
  setActivateEduUserEdit,
  editUserType,
  setEditUserType,
}) {
  const [formval, setFormval] = useState(userData);
  const { campus, campus_details } = userData;
  //   useEffect(() => {
  //     (async () => {
  //       let response = await axios(`${baseUrl}/module/admin/user-viewset/${id}`, {
  //         method: "GET",
  //         headers: {
  //           Authorization: "Token " + localStorage.getItem("token"),
  //         },
  //       });
  //       if (response?.data.code === 200) {
  //         let responsedata=response.data.data
  //         responsedata.mobile=responsedata.country_code+responsedata.mobile
  //         setFormval(responsedata);
  //       }
  //     })();
  //   }, []);

  return (
    <>
      <div className="row">
        <div className="col-lg-12">
          <div className="cards edit-usr">
            <form action="">
              <div className="row">
                <div className="col-lg-3 mb-4">
                  <label htmlFor="" className="form-label">
                    First Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="first_name"
                    disabled
                    defaultValue={formval?.first_name}
                  />
                </div>
                <div className="col-lg-3 mb-4">
                  <label htmlFor="" className="form-label">
                    Last Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="last_name"
                    disabled
                    defaultValue={formval?.last_name}
                  />
                </div>
                <div className="col-lg-3 mb-4">
                  <label htmlFor="" className="form-label">
                    Mobile Number
                  </label>
                  <PhoneInput
                    name="mobile"
                    country={formval.country_code}
                    value={formval.country_code + formval.mobile}
                    placeholder="Mobile number"
                    style={{
                      backgroundColor: "#e9ecef",
                    }}
                    inputStyle={{
                      width: "100%",
                      height: "37px",
                      backgroundColor: "#e9ecef",
                    }}
                    disabled
                    // onChange={ChangeHandler}
                    containerStyle={{
                      padding: "40px",
                    }}
                  />
                </div>
                <div className="col-lg-3 mb-4">
                  <label htmlFor="" className="form-label">
                    User Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="mobile"
                    disabled
                    defaultValue={formval?.username}
                  />
                </div>
                <div className="col-lg-3 mb-4">
                  <label htmlFor="" className="form-label">
                    Email
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="email"
                    disabled
                    defaultValue={formval?.email}
                  />
                </div>
                <div className="col-lg-3 mb-4">
                  <label htmlFor="" className="form-label">
                    Role
                  </label>
                  <select
                    name="user_type"
                    disabled
                    className="form-select"
                    value={formval?.user_type}
                  >
                    <option>Roles</option>
                    <option value={"CLEANER"}>Cleaner</option>;
                    <option value={"CLEANING_MANAGER"}>Cleaning Manager</option>
                    <option value={"CLIENT"}>Client</option>
                  </select>
                </div>
                <div className="col-lg-3 mb-4">
                  <label htmlFor="" className="form-label">
                    Campus
                  </label>
                  <select
                    name="user_type"
                    className="form-select"
                    value={campus_details
                      ?.map((k) => k?.campus_name)
                      .join(", ")}
                  >
                    {formval?.campus_details?.map((arr) => (
                      <option value="" key={arr?.id}>
                        {arr?.campus_details
                          ?.map((k) => k?.campus_name)
                          .join(", ")}
                        {arr?.campus_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-lg-3 mb-4">
                  <label htmlFor="" className="form-label">
                    Company
                  </label>
                  <select name="user_type" disabled className="form-select">
                    {formval?.company?.company_name === undefined ? (
                      <option value="">No Company</option>
                    ) : (
                      <option value="">{formval?.company?.company_name}</option>
                    )}
                  </select>
                </div>

                <div className="col-lg-12 d-flex w-100 justify-content-center gap-2">
                  <Link
                    role="button"
                    type="Submit"
                    className="thm-btn"
                    onClick={() => {
                      setUserData({});
                      setShowList(true);
                    }}
                  >
                    <i className="fa fa-chevron-left" /> &nbsp; back
                  </Link>
                  <Link
                    role="button"
                    className="thm-btn"
                    data-bs-toggle="modal"
                    data-bs-target={
                      formval?.company
                        ? "#edit-admin-modal"
                        : "#edit-user-modal"
                    }
                    onClick={(e) => {
                      // setUserData(ul);
                      setEditUserType(formval?.company ? "admin" : "user");
                      setActivateEduUserEdit(true);
                    }}
                  >
                    <i className="fa fa-edit " />
                    &nbsp; Edit
                  </Link>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
